import React from 'react'

type ThankYouProps = {
  className?: string
}

export const ThankYou = ({ className }: ThankYouProps) => (
  <svg
    aria-label="Thank you"
    className={className}
    data-testid="thank-you"
    width="70"
    height="70"
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="70" height="70" fill="#FF0032" />
    <path
      d="M8.84775 20.056V29H11.8718V20.056H15.1358V17.176H5.56775V20.056H8.84775ZM16.5274 29H19.5194V24.552H23.6634V29H26.6714V17.176H23.6634V21.688H19.5194V17.176H16.5274V29ZM36.1158 29H39.1878L34.9798 17.176H32.1958L27.8758 29H30.9638L31.6678 26.84H35.4278L36.1158 29ZM34.7078 24.248H32.4198L33.5878 20.744L34.7078 24.248ZM48.034 17.176V23.592L42.562 17.176H40.418V29H43.346V22.664L48.722 29H50.978V17.176H48.034ZM60.2046 29H63.8526L59.5486 22.408L63.6446 17.176H60.0286L56.3006 22.04V17.176H53.3086V29H56.3006V26.296L57.5806 24.744L60.2046 29Z"
      fill="white"
    />
    <path
      d="M25.1599 32.525H19.6849L16.3599 39.6L13.1349 32.525H7.63486L14.0349 44.8V51H18.6849V44.8L25.1599 32.525ZM34.4899 51.3C40.0149 51.3 44.1399 47.075 44.1399 41.775C44.1399 36.45 39.9899 32.2 34.4649 32.2C28.9649 32.2 24.8149 36.425 24.8149 41.775C24.8149 47.1 28.9149 51.3 34.4899 51.3ZM34.4649 46.675C31.7899 46.675 29.6399 44.625 29.6399 41.75C29.6399 38.9 31.8149 36.825 34.4649 36.825C37.0899 36.825 39.2899 38.825 39.3149 41.75C39.3149 44.575 37.2149 46.675 34.4649 46.675ZM54.2593 51.325C58.1093 51.325 61.8843 49.275 61.8843 43.825V32.525H57.1593V43.75C57.1593 45.9 55.8343 46.825 54.2593 46.825C52.6593 46.825 51.3343 45.925 51.3343 43.75V32.525H46.6343V43.825C46.6343 49.275 50.4343 51.325 54.2593 51.325Z"
      fill="white"
    />
  </svg>
)
